import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ISipCall } from '@obvious.tech/constellation'

export const SipCall = defineEntity('SipCall', {
  endpoint: 'sip/api/SipCall',
  schema: SNoop<ISipCall>(),
})
